import Feeds from "@/src/screens/feeds/feeds";

export default function FeedsScreen() {
  return <Feeds />;
}
